import React from "react";
import PropTypes from "prop-types";
import { ActionIcon, Tooltip, useMantineTheme } from "@mantine/core";
import IconFileTypePdf from "@tabler/icons-react/dist/esm/icons/IconFileTypePdf.mjs";
import IconFileTypeXls from "@tabler/icons-react/dist/esm/icons/IconFileTypeXls.mjs";

const ExportFileButton = ({
  handleDownload = () => {},
  loading = false,
  type = "PDF",
  tooltipLabel = "",
  disabled = false,
}) => {
  const theme = useMantineTheme();

  return (
    <Tooltip label={tooltipLabel}>
      <ActionIcon
        bg={"transparent"}
        loaderProps={{ color: theme.colors.primary[7] }}
        loading={loading}
        disabled={disabled}
        onClick={handleDownload}
      >
        {type === "PDF" ? (
          <IconFileTypePdf color={disabled ? "gray" : theme.colors.primary[7]} />
        ) : null}

        {type === "EXCEL" ? (
          <IconFileTypeXls color={disabled ? "gray" : theme.colors.primary[7]} />
        ) : null}
      </ActionIcon>
    </Tooltip>
  );
};

ExportFileButton.propTypes = {
  tooltipLabel: PropTypes?.string,
  loading: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["PDF", "EXCEL"]).isRequired,
  disabled: PropTypes.bool,
};

export default ExportFileButton;
